/** Immutable registry and contact data for Fundacja "Poznaj Świat". */
export const FOUNDATION_FACTS = {
  fullName: 'Fundacja "Poznaj Świat"',
  legalForm: "Fundacja",
  krs: "0001183281",
  nip: "5423502510",
  regon: "542221448",
  address: "ul. Warszawska 6 lok. 32, 15-063 Białystok",
  email: "poznajswiatbialystok@gmail.com",
  phone: "690 191 147",
  phoneSecondary: "666 531 834"
} as const;
